import React, { Component } from 'react'
import { connect } from 'react-redux'
import Modal from '../Shared/Modal'



class ModalProgress extends Component {


    render() {

        const { modalProgress } = this.props
        
        if (!modalProgress.get('show')) {
            return null
        }

        return(
            <Modal id="ModalProgress" show={ true } ZIndex={ 2000 }>
                <div style={{ textAlign:'center', width: '200px', padding: '10px', color: 'green', fontWeight: 'bold' }}>
                    Sincronizando...
                </div>
            </Modal>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        modalProgress: state.maestras.get('modalProgress'),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalProgress)


// WEBPACK FOOTER //
// ./src/components/Maestra/ModalProgress.jsx